import { defaultPresets } from "./viewPreset";

/**
 * Scheduler の設定を fiscalStartMonth・fiscalYear に基づいて生成
 * @returns {object} schedulerConfig
 */
export function createSchedulerConfig() {
  return {
    presets: defaultPresets,
    viewPreset: "day",
    rowHeight: 50,
    stripeFeature: true, // ストライプÏ表示
    dependenciesFeature: false, // dependenciesは使用しない
    dependencyEditFeature: false, // dependenciesの編集は使用しない
    percentBarFeature: false, // percentBarは使用しない
    timeRangesFeature: true, // 現在時刻のバー表示
    treeFeature: false, // ツリー表示はしない
    zoomOnMouseWheel: false, // マウスホイールでのズームは無効
    cellTooltipFeature: false, // リソースのツールチップは使用しない
    filterFeature: false, // フィルタ機能は使用しない
    sortFeature: false, // ソート機能は使用しない
    cellMenuFeature: false, // リソースのセルメニューは使用しない
    timeAxisHeaderMenuFeature: false, // タイムアクシスメニューは使用しない
    timeSpanHighlightFeature: true, // 背景ハイライト機能
    loadMaskError: false, // ロード時のエラーメッセージを表示しない
    zoomOnTimeAxisDoubleClick: false,
  };
}
